import type { ThemeClasses } from "../types";
import type { TFunction } from "i18next";
import { useDisableCRUD } from "../../../../../../store/admin/companiesStore";
import useIsMonitor from "../../../../../../hooks/useIsMonitor";
import { CRUDTooltip } from "../../../../../../components/base/CRUDTooltip";

interface TripHeaderProps {
  themeClasses: ThemeClasses;
  onCreateTrip: () => void;
  t: TFunction;
}

export function TripHeader({ themeClasses, onCreateTrip, t }: TripHeaderProps) {
  const disableCRUD = useDisableCRUD();
  const { isMonitor, isReadOnly } = useIsMonitor();
  return (
    <div className={`${themeClasses.bg} p-4 sm:p-6 pb-0`}>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 mb-4">
        <div className="min-w-0">
          <h1 className={`text-xl sm:text-2xl font-bold ${themeClasses.text}`}>
            {t("trips.title")}
          </h1>
          <p className={`text-sm ${themeClasses.textSecondary} mt-1`}>
            {t("trips.subtitle")}
          </p>
        </div>
        {!isMonitor && !isReadOnly && (
          <CRUDTooltip className="self-start sm:self-auto flex-shrink-0">
            <button
              onClick={onCreateTrip}
              disabled={disableCRUD}
              className="px-3 sm:px-4 py-2 bg-primary-500 hover:bg-primary-400 text-gray-900 rounded-lg font-medium transition-colors flex items-center justify-center gap-2 text-sm sm:text-base"
            >
              <i className="ri-add-line"></i>
              <span className="hidden sm:inline">{t("trips.addTrip")}</span>
              <span className="sm:hidden">Nuevo</span>
            </button>
          </CRUDTooltip>
        )}
      </div>
    </div>
  );
}
